export default __webpack_public_path__ + "static/media/2017-roadpatch.cad60c3c.png";